import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { NbJSThemesRegistry, NbThemeService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

import { UsersService } from 'src/app/@core/backend/common/services/users.service';
import { UserStore } from '../../@core/stores/user.store';
import { User } from '../../@core/interfaces/common/users';

@Injectable()
export class InitUserService {
  constructor(
    protected userStore: UserStore,
    protected usersService: UsersService,
    protected jsThemes: NbJSThemesRegistry,
    protected themeService: NbThemeService,
    private translate: TranslateService
  ) { }

  initCurrentUser(): Observable<User> {
    return this.usersService.getCurrentWithInfo().pipe(
      tap((user: any) => {
        if (user) {
          this.userStore.setUser(user);
          if (user.user?.locale) {
            this.translate.use(user.user.locale);
          }
        }
      })
    );
  }
}
